import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Routes, Route, Navigate } from 'react-router-dom';
import { companyInfo } from './Components/BaseURL';
import SystemStart from './Components/SystemStart';
import Landing from './Components/Landing/Landing';
import MainLayout from './Components/Layout/MainLayout';
import Dashboard from './Components/Dashboard/Dashboard';
import Record from './Components/Record/Record';
import TY2 from './Components/TY2';
import Pharmacy from './Components/Pharmacy/Pharmacy';
import Login from './Components/Login/LoginChooser';
import Accounts from './Components/Accounts/Accounts';
import Doctors from './Components/Doctors/Doctors';
import AdminPanel from './Components/AdminPanel';
import TY from './Components/TY';
import IdleLogout from './Components/IdleLogout';
import Wards from './Components/Wards/Wards';
import Procurement from './Components/Procurement/Procurement';
import Laboratory from './Components/Laboratory/Laboratory';
import Claims from './Components/Claims/Claims';
import HealthInformation from './Components/Health Information/HealthInformation';
import Emergency from './Components/Emergency/Emergency';
import HumanResources from './Components/HumanResources/HumanResources';
import PWAInstallProvider from './Components/PWAInstallProvider';

const firstWord = (s) => (s || '').toString().trim().split(/\s+/)[0] || '';

const applyBranding = ({ name, logo } = {}) => {
  const tabName = firstWord(name);
  if (tabName) document.title = tabName;
  if (!logo) return;
  const setHref = (id, fallbackTag) => {
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement('link');
      el.id = id;
      el.rel = fallbackTag;
      document.head.appendChild(el);
    }
    el.href = logo;
  };
  setHref('app-favicon', 'icon');
  setHref('app-apple-icon', 'apple-touch-icon');
};

function App() {
  // Track companyInfo in state so the PWA install card and dynamic manifest
  // pick up the facility's name + logo as soon as the API responds. Seeded
  // from localStorage so the first paint after a refresh already has it.
  const [company, setCompany] = useState(() => {
    try {
      const raw = localStorage.getItem('companyInfo');
      return raw ? JSON.parse(raw) : null;
    } catch (_) { return null; }
  });

  useEffect(() => {
    if (company) applyBranding(company);
    axios.get(companyInfo)
      .then(({ data }) => {
        const c = data?.success && Array.isArray(data.results) ? data.results[0] : null;
        if (c) {
          applyBranding(c);
          localStorage.setItem('companyInfo', JSON.stringify(c));
          setCompany(c);
        }
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IdleLogout timeout={10 * 60 * 1000}>  {/* 10 minutes */}
      <PWAInstallProvider companyInfo={company} />
      <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<MainLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="Record" element={<Record />} />
            <Route path="Procurement" element={<Procurement />} />
            <Route path="Pharmacy" element={<Pharmacy />} />
            <Route path="Accounts" element={<Accounts />} />
            <Route path="Doctors" element={<Doctors />} />
            <Route path="Wards" element={<Wards />} />
            <Route path="TY" element={<TY />} />
            <Route path="TY2" element={<TY2 />} />
            <Route path="Laboratory" element={<Laboratory />} />
            <Route path="Claims" element={<Claims />} />
            <Route path="HealthInformation" element={<HealthInformation />} />
            <Route path="Emergency" element={<Emergency />} />
            <Route path="HumanResources" element={<HumanResources />} />
            <Route path="AdminPanel" element={<AdminPanel />} />
          </Route>
      </Routes>
    </IdleLogout>
  );
}

export default App;
